import clsx from 'clsx';
import styles from './index.module.scss';
import { IDriverDocument } from 'common/document/interfaces/driver-document';
import { DriverHeader } from 'App/components/Layouts/Driver/DriverHeader';
import ButtonWithArrowIcon from 'components/Buttons/ButtonWithArrowIcon';
import {
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  SelectChangeEvent,
} from '@mui/material';
import { useState } from 'react';
import { TextButton } from '../../../components/Buttons/TextButton';

export interface SelectDocumentTypeProps {
  documentsToSelect: IDriverDocument[];
  onContinue: (selectedDocument: IDriverDocument) => void;
  onGoBack?: () => void;
  className?: string;
}

function SelectDocumentType(props: SelectDocumentTypeProps) {
  const [selectedDocumentIndex, setSelectedDocument] = useState<number>(0);

  const handleContinue = () => {
    if (selectedDocumentIndex === undefined) return;
    props.onContinue(props.documentsToSelect[selectedDocumentIndex || 0]);
  };

  const handleChange = (event: SelectChangeEvent) => {
    setSelectedDocument(parseInt(event.target.value));
  };

  return (
    <div className={clsx(styles.root, props.className)}>
      <div className={styles.card}>
        <div className={styles.logoContainer}>
          <DriverHeader />
        </div>
        <div>
          <div className={styles.title}>
            Please ONLY select the document(s) you are needing to upload. We
            will not need documents that are already in your driver file, unless
            requested.
          </div>
          <div className={styles.selector}>
            <FormControl
              fullWidth
              classes={{
                root: styles.formControl,
              }}
            >
              <InputLabel
                id="select-document-type"
                classes={{
                  focused: styles.labelFocused,
                }}
              >
                Select Document Type
              </InputLabel>
              <Select
                labelId="select-document-type"
                label="Select Document Type"
                onChange={handleChange}
                value={`${selectedDocumentIndex}`}
              >
                {props.documentsToSelect.map((x, index) => (
                  <MenuItem key={x.id} value={index}>
                    {x.documentName}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>
          <div className={styles.actions}>
            <ButtonWithArrowIcon
              disabled={selectedDocumentIndex === undefined}
              onClick={handleContinue}
              variant="contained"
              color="primary"
            >
              Continue
            </ButtonWithArrowIcon>
            {props.onGoBack && (
              <TextButton onClick={props.onGoBack} color="primary">
                Go Back
              </TextButton>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelectDocumentType;
